import Phaser from 'phaser';
import BaseScene from './base';
import { asyncPlaySound, makeStandardController, StandardController } from 'tower/util';

export default class GameIntroScene extends BaseScene {
  music!: Phaser.Sound.BaseSound;

  constructor(config: Phaser.Types.Scenes.SettingsConfig = {}) {
    super({
      key: 'game-intro',
      ...config,
    });
  }

  ready = false;
  controller!: StandardController;

  loadResources(scene: Phaser.Scene) {
    scene.load.audio('gameIntro', 'audio/gameintro.mp3');
    scene.load.image('leafBox', 'img/leafbox.png');
  }

  create() {
    super.create();

    this.music = this.sound.add('gameIntro');

    this.controller = makeStandardController(this);

    this.add.nineslice(128, 128, 'leafBox', 0, 240, 176, 16, 16, 16, 16, true, true);

    this.add.rectangle(128, 44, 176, 8, 0x000000);
    this.add.bitmapText(48, 40, 'textRed', 'THE TOWER OF ZELDAGA');
    this.add.bitmapText(24, 64, 'textWhite', 'PRINCE GANONDORF HAS BEEN\n\nKIDNAPPED BY THE DEMON\n\nQUEEN ZELDAGA');
    this.add.bitmapText(24, 128, 'textWhite', 'ASCEND THE TOWER OF\n\nZELDAGA TO SAVE HIM, BUT\n\nBE WARNED');
    this.add.bitmapText(24, 192, 'textRed', 'EVERY ROOM HIDES A SECRET!');

    const pressStart = this.add.bitmapText(80, 224, 'textWhite', 'PRESS  START').setVisible(false);

    (async () => {
      await asyncPlaySound(this.music);
      pressStart.setVisible(true);
      this.ready = true;
    })();

    if (window.location.search.includes('debug')) {
      this.ready = true;
    }
  }

  handleButtonPress = async () => {
    this.ready = false;

    // Display touch controls for devices with touchscreens as the primary control
    if (window.matchMedia('(pointer: coarse)').matches) {
      document.querySelector('#touch-controls')?.classList.remove('hidden');
    }

    this.music.stop();
    await this.fadeOut();
    this.scene.start('level-intro');
  };

  update() {
    const { controller, ready } = this;
    if (ready) {
      if (Object.values(controller).some((b) => b.isDown)) {
        this.handleButtonPress();
      }
    }
  }
}
